import React from 'react';
import { ArmchairIcon, HammerIcon, LibraryIcon, RulerIcon } from 'lucide-react';
import { SNAPSHOT, type SnapshotIcon } from '../../data/woodworking';
const ICONS: Record<SnapshotIcon, React.ComponentType<{
  className?: string;
}>> = {
  projects: ArmchairIcon,
  volumes: LibraryIcon,
  dimensions: RulerIcon,
  rights: HammerIcon
};

/** Forest-green value band separating the light hero from the sections below. */
export function ValueStrip() {
  return <section aria-label="What's included" className="border-y border-brass-light/25 bg-bottle" data-id="element-380" data-mp="38dpf0ggrkkkg">
      <ul className="mx-auto grid w-full max-w-6xl grid-cols-2 px-5 sm:px-8 lg:grid-cols-4" data-id="element-381" data-mp="34c48dcutp2ip">
        {SNAPSHOT.map((item, index) => {
        const Icon = ICONS[item.icon];
        return <li key={item.label} className={`flex flex-col items-center gap-2 px-2 py-4 text-center sm:flex-row sm:justify-center sm:gap-3 sm:py-5 sm:text-left ${index % 2 === 1 ? 'border-l border-white/15' : ''} ${index >= 2 ? 'border-t border-white/15 lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-382" data-mp="2ui3v2npe0qyw" data-mpi={index}>
              <Icon className="h-5 w-5 shrink-0 text-brass-light" aria-hidden data-id="element-383" data-mp="1f9ft2txlrsgv" />
              <span className="text-balance text-[0.74rem] font-semibold uppercase leading-tight tracking-[0.08em] text-ivory sm:text-[0.82rem]" data-id="element-384" data-mp="11i1bmrjcfzbx">
                {item.label}
              </span>
            </li>;
      })}
      </ul>
    </section>;
}